import styles from "./Containers.module.css";
import DataLabel from "../labels/DataLabel";
import QuestionSection from "../../../pages/contractorAudit/auditQuestions/QuestionSection";
import useQuestions from "../../../hooks/useAuditQuestions";

const SplicerToolListCard = ({ toolList }) => {
  const { splicerToolQuestions } = useQuestions();

  return (
    <>
      <div className={styles.toolListCard}>
        <QuestionSection title="Tool List">
          <DataLabel
            title={splicerToolQuestions.bareFiberAdapterMakeModel}
            text={
              toolList?.BARE_FIBER_ADAPTER_MAKE_MODEL
                ? toolList.BARE_FIBER_ADAPTER_MAKE_MODEL
                : "N/A"
            }
          />
          <DataLabel
            title={splicerToolQuestions.bufferTubeMakeModel}
            text={
              toolList?.BUFFER_TUBE_MAKE_MODEL
                ? toolList.BUFFER_TUBE_MAKE_MODEL
                : "N/A"
            }
          />
          <DataLabel
            title={splicerToolQuestions.conesMakeModel}
            text={
              toolList?.CONES_MAKE_MODEL ? toolList.CONES_MAKE_MODEL : "N/A"
            }
          />
          <DataLabel
            title={splicerToolQuestions.coreTubeEntryKitMakeModel}
            text={
              toolList?.CORE_TUBE_ENTRY_KIT_MAKE_MODEL
                ? toolList.CORE_TUBE_ENTRY_KIT_MAKE_MODEL
                : "N/A"
            }
          />
          <DataLabel
            title={splicerToolQuestions.drill}
            text={
              toolList?.DRILL_MAKE_MODEL ? toolList.DRILL_MAKE_MODEL : "N/A"
            }
          />
          <DataLabel
            title={splicerToolQuestions.exfoLaunchBagMakeModel}
            text={
              toolList?.EXFO_LAUNCH_BAG_MAKE_MODEL
                ? toolList.EXFO_LAUNCH_BAG_MAKE_MODEL
                : "N/A"
            }
          />
          <DataLabel
            title={splicerToolQuestions.fiberMakeModel}
            text={
              toolList?.FIBER_MAKE_MODEL ? toolList.FIBER_MAKE_MODEL : "N/A"
            }
          />
          <DataLabel
            title={splicerToolQuestions.foDropSlitterMakeModel}
            text={
              toolList?.FIBER_OPTIC_DROP_SPLITTER_MAKE_MODEL
                ? toolList.FIBER_OPTIC_DROP_SPLITTER_MAKE_MODEL
                : "N/A"
            }
          />
          <DataLabel
            title={splicerToolQuestions.fiberSerial}
            text={toolList?.FIBER_SERIAL ? toolList.FIBER_SERIAL : "N/A"}
          />
          <DataLabel
            title={splicerToolQuestions.fishTapeMakeModel}
            text={
              toolList?.FISH_TAPE_MAKE_MODEL
                ? toolList.FISH_TAPE_MAKE_MODEL
                : "N/A"
            }
          />
          <DataLabel
            title={splicerToolQuestions.fsMachineRibbonMakeModel}
            text={
              toolList?.FUSION_SPLICE_MACHINE_RIBBON_MAKE_MODEL
                ? toolList.FUSION_SPLICE_MACHINE_RIBBON_MAKE_MODEL
                : "N/A"
            }
          />
          <DataLabel
            title={splicerToolQuestions.fsMachineRibbonSerial}
            text={
              toolList?.FUSION_SPLICE_MACHINE_RIBBON_SERIAL
                ? toolList.FUSION_SPLICE_MACHINE_RIBBON_SERIAL
                : "N/A"
            }
          />
          <DataLabel
            title={splicerToolQuestions.fsMachineSingleMakeModel}
            text={
              toolList?.FUSION_SPLICE_MACHINE_SINGLE_MAKE_MODEL
                ? toolList.FUSION_SPLICE_MACHINE_SINGLE_MAKE_MODEL
                : "N/A"
            }
          />
          <DataLabel
            title={splicerToolQuestions.fsMachineSingleSerial}
            text={
              toolList?.FUSION_SPLICE_MACHINE_SINGLE_SERIAL
                ? toolList.FUSION_SPLICE_MACHINE_SINGLE_SERIAL
                : "N/A"
            }
          />
          <DataLabel
            title={splicerToolQuestions.handToolsMakeModel}
            text={
              toolList?.HAND_TOOLS_MAKE_MODEL
                ? toolList.HAND_TOOLS_MAKE_MODEL
                : "N/A"
            }
          />
          <DataLabel
            title={splicerToolQuestions.harnessMakeModel}
            text={
              toolList?.HARNESS_MAKE_MODEL ? toolList.HARNESS_MAKE_MODEL : "N/A"
            }
          />
          <DataLabel
            title={splicerToolQuestions.ladder28ftMakeModel}
            text={
              toolList?.LADDER_LONG_MAKE_MODEL
                ? toolList.LADDER_LONG_MAKE_MODEL
                : "N/A"
            }
          />
          <DataLabel
            title={splicerToolQuestions.ladder6ftMakeModel}
            text={
              toolList?.LADDER_SHORT_MAKE_MODEL
                ? toolList.LADDER_SHORT_MAKE_MODEL
                : "N/A"
            }
          />
          <DataLabel
            title={splicerToolQuestions.midspanSplitterMakeModel}
            text={
              toolList?.MIDSPAN_SPLITTER_MAKE_MODEL
                ? toolList.MIDSPAN_SPLITTER_MAKE_MODEL
                : "N/A"
            }
          />
          <DataLabel
            title={splicerToolQuestions.midspanSplitterMakeModel}
            text={
              toolList?.MIDSPAN_SPLITTER_MAKE_MODEL
                ? toolList.MIDSPAN_SPLITTER_MAKE_MODEL
                : "N/A"
            }
          />
          <DataLabel
            title={splicerToolQuestions.opticalLossMakeModel1}
            text={
              toolList?.OPTICAL_LOSS_MAKE_MODEL_1
                ? toolList.OPTICAL_LOSS_MAKE_MODEL_1
                : "N/A"
            }
          />
          <DataLabel
            title={splicerToolQuestions.opticalLossSerial1}
            text={
              toolList?.OPTICAL_LOSS_SERIAL_1
                ? toolList.OPTICAL_LOSS_SERIAL_1
                : "N/A"
            }
          />{" "}
          <DataLabel
            title={splicerToolQuestions.opticalLossMakeModel2}
            text={
              toolList?.OPTICAL_LOSS_MAKE_MODEL_2
                ? toolList.OPTICAL_LOSS_MAKE_MODEL_2
                : "N/A"
            }
          />
          <DataLabel
            title={splicerToolQuestions.opticalLossSerial2}
            text={
              toolList?.OPTICAL_LOSS_SERIAL_2
                ? toolList.OPTICAL_LOSS_SERIAL_2
                : "N/A"
            }
          />
          <DataLabel
            title={splicerToolQuestions.otdrMakeModel}
            text={toolList?.OTDR_MAKE_MODEL ? toolList.OTDR_MAKE_MODEL : "N/A"}
          />
          <DataLabel
            title={splicerToolQuestions.otdrSerial}
            text={toolList?.OTDR_SERIAL ? toolList.OTDR_SERIAL : "N/A"}
          />
          <DataLabel
            title={splicerToolQuestions.safetyVestAndHardHatMakeModel}
            text={
              toolList?.SAFETY_VEST_HARD_HAT_MAKE_MODEL
                ? toolList.SAFETY_VEST_HARD_HAT_MAKE_MODEL
                : "N/A"
            }
          />
          <DataLabel
            title={splicerToolQuestions.signAndHolderMakeModel}
            text={
              toolList?.SIGN_AND_HOLDER_MAKE_MODEL
                ? toolList.SIGN_AND_HOLDER_MAKE_MODEL
                : "N/A"
            }
          />
          <DataLabel
            title={splicerToolQuestions.splicerTentMakeModel}
            text={
              toolList?.SPLICER_TENT_MAKE_MODEL
                ? toolList.SPLICER_TENT_MAKE_MODEL
                : "N/A"
            }
          />
          <DataLabel
            title={splicerToolQuestions.splicingTableMakeModel}
            text={
              toolList?.SPLICING_TABLE_MAKE_MODEL
                ? toolList.SPLICING_TABLE_MAKE_MODEL
                : "N/A"
            }
          />
          <DataLabel
            title={splicerToolQuestions.toolsetMakeModel}
            text={
              toolList?.TOOLSET_MAKE_MODEL ? toolList.TOOLSET_MAKE_MODEL : "N/A"
            }
          />
          <DataLabel
            title={splicerToolQuestions.trailerTypeAndNum}
            text={
              toolList?.TRAILER_TYPE_AND_NUM
                ? toolList.TRAILER_TYPE_AND_NUM
                : "N/A"
            }
          />
          <DataLabel
            title={splicerToolQuestions.vehicleNumber}
            text={toolList?.VECHICLE_NUMBER ? toolList.VECHICLE_NUMBER : "N/A"}
          />
          <DataLabel
            title={splicerToolQuestions.vehicleType}
            text={toolList?.VEHICLE_TYPE ? toolList.VEHICLE_TYPE : "N/A"}
          />
          <DataLabel
            title={splicerToolQuestions.toolNotes}
            text={toolList?.NOTES ? toolList.NOTES : "N/A"}
          />
        </QuestionSection>
      </div>
    </>
  );
};

export default SplicerToolListCard;
